import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useSteps } from '../../../../hooks/use-steps.js';
import ConfiguratorStepTitleAndDescription from './ConfiguratorStepTitleAndDescription.js';

const ConfiguratorStepTitleAndDescriptionContainer = ({ textAlignment , titleClassName , descriptionClassName ,  })=>{
    const { getLabel , getFormattedLabel , hasLabel  } = useIntl();
    const { currentStep  } = useSteps();
    const { title , description  } = currentStep.labelKeys;
    const labels = React.useMemo(()=>({
            title: getLabel(title),
            description: description && hasLabel(description) ? getFormattedLabel(description, {
                parseLink: true,
                openLinksInNewTab: true,
                hideLabelKey: true
            }) : undefined
        })
    , [
        getLabel,
        title,
        description,
        getFormattedLabel,
        hasLabel
    ]);
    return /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, swcHelpers.extends({}, labels, {
        textAlignment: textAlignment,
        titleClassName: titleClassName,
        descriptionClassName: descriptionClassName
    }));
};

export { ConfiguratorStepTitleAndDescriptionContainer as default };
//# sourceMappingURL=ConfiguratorStepTitleAndDescriptionContainer.js.map
